import { Injectable } from '@angular/core';
import { RestApiService } from './rest-api.service';
import { HttpClient } from '@angular/common/http';
import { Announcement, AnnouncementCategory, CustomerPDA, Goal, GoalLatest, Institute, LaunchKey, Phrase, PublicStatistics, Reminder } from 'src/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UtilsService extends RestApiService {
  //Variáveis
  selectedPhrase = ''; //Frase Aleatória Diária Selecionada Para o Usuário

  private _urlPhrases = '/motivational-phrases';
  private _urlPhrase = '/motivational-phrases/:phraseId';
  private _urlUserPhrase = '/users/motivational-phrase';

  private _urlReminders = '/reminders';
  private _urlReminder = '/reminders/:reminderId';

  private _urlGoals = '/plans/:planId/goals';
  private _urlGoal = '/plans/:planId/goals/:goalId';

  private _urlPublicStatistics = '/public/statistics';

  private _urlPublicAnnouncements = '/public/announcements';
  private _urlPublicAnnouncementCategories = '/public/announcement-categories';
  private _urlPublicInstitutes = '/public/institutes';

  private _urlCustomerPDA = '/customer-pda/search';

  private _urlLaunchKey = '/secrets';


  constructor(public http: HttpClient) {
    super(http);
  }


  ///////////////////////////
  //////////////////// IMAGEM
  ///////////////////////////
  getServerImage(path: string) {
    return this.getBlob(path) as Observable<Blob>;
  }


  ///////////////////////////////////////
  //////////////////// FRASE MOTIVACIONAL
  ///////////////////////////////////////
  getPhrases(filter?: Object) {
    let url = this._urlPhrases;
    url += filter ? '?filter=' + JSON.stringify(filter) : '';

    return this.get(url, Phrase) as Observable<Phrase[]>;
  }

  createPhrase(phrase: Phrase) {
    const url = this._urlPhrases;
    return this.post(url, phrase, Phrase);
  }

  getPhrase(phraseId: number) {
    const url = this._urlPhrase.replace(':phraseId', phraseId.toString());
    return this.get(url, Phrase) as Observable<Phrase>;
  }

  updatePhrase(phrase: Phrase) {
    const url = this._urlPhrase.replace(':phraseId', phrase.id.toString());
    return this.put(url, phrase, Phrase);
  }

  deletePhrase(phrase: Phrase) {
    const url = this._urlPhrase.replace(':phraseId', phrase.id.toString());
    return this.del(url, Phrase);
  }

  getTodayPhrase() {
    const storage = JSON.parse(localStorage.getItem('motivationalPhrase') || '{}');

    //Requisição de Frase Aleatória Diária do Usuário
    const req = () => {
      const url = this._urlUserPhrase;
      (this.get(url, Phrase) as Observable<Phrase>).subscribe(
        (next) => {
          const finalDay = new Date(); finalDay.setUTCHours(23, 59, 59, 59);
          const today = {
            id: next.id,
            expires: finalDay.toISOString(),
            phrase: next.text,
            author: next.author
          };
          localStorage.setItem('motivationalPhrase', JSON.stringify(today));
          this.selectedPhrase = next.author ? `“${next.text}” — ${next.author}` : `${next.text}`;
        }
      );
    };

    //Se Houver Frase no localStorage
    if (storage?.id) {
      const now = new Date();
      const expires = new Date(storage['expires']);
      //Expiração da Frase Atual
      if (now.getTime() > expires.getTime())
        req(); //Requisitar Nova Frase
      else //Persistir Atual no Serviço
        this.selectedPhrase = storage.author ? `“${storage.phrase}” — ${storage.author}` : `${storage.phrase}`;
    } else { //Não Há Frase
      req();
    }
  }


  /////////////////////////////
  //////////////////// LEMBRETE
  /////////////////////////////
  getReminders() {
    const url = this._urlReminders;
    return this.get(url, Reminder) as Observable<Reminder[]>;
  }

  createReminder(reminder: Reminder) {
    const url = this._urlReminders;
    return this.post(url, reminder, Reminder);
  }

  getReminder(reminderId: number) {
    const url = this._urlReminder.replace(':reminderId', reminderId.toString());
    return this.get(url, Reminder) as Observable<Reminder>;
  }

  updateReminder(reminder: Reminder) {
    const url = this._urlReminder.replace(':reminderId', reminder.id.toString());
    return this.put(url, reminder, Reminder);
  }

  deleteReminder(reminder: Reminder) {
    const url = this._urlReminder.replace(':reminderId', reminder.id.toString());
    return this.del(url, Reminder);
  }


  ////////////////////////////////////
  //////////////////// METAS DE ESTUDO
  ////////////////////////////////////
  getGoals(planId: number) {
    const url = this._urlGoals.replace(':planId', planId.toString());
    return this.get(url, Goal) as Observable<Goal[]>;
  }

  createGoal(planId: number, reminder: Goal) {
    const url = this._urlGoals.replace(':planId', planId.toString());
    return this.post(url, reminder, Goal);
  }

  getGoal(planId: number, goalId: number) {
    const url = this._urlGoal.replace(':planId', planId.toString()).replace(':goalId', goalId.toString());
    return this.get(url, Goal) as Observable<Goal>;
  }

  updateGoal(planId: number, goal: Goal) {
    const url = this._urlGoal.replace(':planId', planId.toString()).replace(':goalId', goal.id.toString());
    return this.put(url, goal, Goal);
  }

  deleteGoal(planId: number, goal: Goal) {
    const url = this._urlGoal.replace(':planId', planId.toString()).replace(':goalId', goal.id.toString());
    return this.del(url, Goal);
  }

  getGoalLatest(planId: number) {
    let url = (this._urlGoals + '/latest').replace(':planId', planId.toString());
    url += `?timezone=${Math.round((new Date()).getTimezoneOffset() / 60) * -1}`;
    return this.get(url, GoalLatest) as Observable<GoalLatest>;
  }


  //////////////////////////////////////////
  //////////////////// ESTATÍSTICAS PÚBLICAS
  //////////////////////////////////////////
  getPublicStatistics() {
    const url = this._urlPublicStatistics;
    return this.get(url, PublicStatistics) as Observable<PublicStatistics>;
  }


  //////////////////////////////////////////
  ///////////////////////// EDITAIS PÚBLICOS
  //////////////////////////////////////////
  getPublicAnnouncements(page?: number, perPage?: number, filters?: any) {
    let url = this._urlPublicAnnouncements;
    url += `?page=${page}&perPage=${perPage}`;

    const keyValuePairs = [];
    for (let key in filters) {
      if (filters[key] && encodeURIComponent(filters[key]))
        keyValuePairs.push(`${encodeURIComponent(key)}=${encodeURIComponent(filters[key])}`);
    }
    url += (`&${keyValuePairs.join('&')}`);

    return this.get(url, Announcement) as Observable<Announcement[]>;
  }

  getPublicAnnouncementCategories() {
    const url = this._urlPublicAnnouncementCategories;
    return this.get(url, AnnouncementCategory) as Observable<AnnouncementCategory[]>;
  }

  getPublicInstitutes() {
    const url = this._urlPublicInstitutes;
    return this.get(url, Institute) as Observable<Institute[]>;
  }


  /////////////////////////////////////////
  //////////////////// PLANILHA DO APROVADO
  /////////////////////////////////////////
  searchCustomerPDA(customer: CustomerPDA) {
    let url = `${this._urlCustomerPDA}?`;
    if (customer.document) url += `document=${customer.document}&`;
    if (customer.email) url += `email=${customer.email}`;

    return this.get(url, CustomerPDA) as Observable<CustomerPDA>;
  }


  ////////////////////////////////////////
  //////////////////// CHAVE DE LANÇAMENTO
  ////////////////////////////////////////
  getLaunchKey() {
    const url = this._urlLaunchKey;
    return this.get(url, LaunchKey) as Observable<LaunchKey>;
  }

}
